
import { Component, Vue } from "nuxt-property-decorator";
import SkipToContent from "~/components/atoms/SkipToContent.vue";
import Footer from "~/components/organisms/nav/Footer.vue";
import FooterPellets from "~/components/organisms/nav/FooterPellets.vue";
import Header from "~/components/organisms/nav/Header.vue";
import { isPelletsDirectory } from "~/operations";
import { tabExitHandler } from "~/operations/meta-helper-functions";

@Component({
  components: {
    SkipToContent,
    Header,
    Footer,
    FooterPellets,
  },
})
export default class ShopLayout extends Vue {
  head() {
    return {
      htmlAttrs: { lang: "de" },
    };
  }

  mounted() {
    this.detectUserLeftTab();
  }
  detectUserLeftTab() {
    tabExitHandler(this);
  }

  isShortVersion = false;

  fetch() {
    this.isShortVersion = Boolean(this.$route.query?.shortVersion) ?? false;
  }

  get isPellets() {
    return isPelletsDirectory(this.$route);
  }
}
